import Bubbles from './Bubbles';
import Kelp from './Kelp';
import LightRays from './LightRays';

const OceanAesthetics = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: -1,
      }}
      aria-hidden="true"
    >
      {/* Layer 0: Subtle volumetric light rays */}
      <LightRays />

      {/* Layer 1: Rising Bubbles */}
      <Bubbles />

      {/* Layer 2: Swaying Kelp Forest - Multiple depths for parallax effect */}
      {/* Foreground kelp - larger, more opaque */}
      <Kelp
        style={{
          position: 'absolute',
          bottom: 0,
          left: '8%',
          opacity: 0.65,
          transform: 'scale(1.1)',
        }}
      />
      <Kelp
        style={{
          position: 'absolute',
          bottom: 0,
          right: '15%',
          opacity: 0.6,
          transform: 'scaleX(-1) scale(1.05)',
        }}
      />

      {/* Mid-ground kelp */}
      <Kelp
        style={{
          position: 'absolute',
          bottom: 0,
          left: '25%',
          opacity: 0.5,
          transform: 'scale(0.85)',
        }}
      />
      <Kelp
        style={{
          position: 'absolute',
          bottom: 0,
          right: '35%',
          opacity: 0.45,
          transform: 'scaleX(-1) scale(0.8)',
        }}
      />

      {/* Background kelp - smaller, more transparent */}
      <Kelp
        style={{
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%) scale(0.65)',
          opacity: 0.35,
        }}
      />
      <Kelp
        style={{
          position: 'absolute',
          bottom: 0,
          right: '5%',
          opacity: 0.3,
          transform: 'scaleX(-1) scale(0.7)',
        }}
      />
    </div>
  );
};

export default OceanAesthetics;
